import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const DashboardRedirect = () => {
  const { startupId } = useParams();
  return <Navigate to={`/startups/${startupId}/profile`} replace />;
};

export default DashboardRedirect;
